import ZoomOnHover from "vue-zoom-on-hover";
import Vue from "vue";

Vue.use(ZoomOnHover);
